import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes that require the user to be logged in.
 * If user is not authenticated (no serviceToken), redirects immediately to /login.
 */
export default function AuthGuard({ children }) {
  const token = localStorage.getItem('serviceToken');
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.node
};
